import { create } from 'zustand';


export interface IPilotAssignmentStore {
    hasEditableChanged: boolean;
    setHasEditableChanged: (data: boolean) => void;
}

export const createPilotAssignmentStore = () =>
    create<IPilotAssignmentStore>((set) => ({
        hasEditableChanged: false,
        setHasEditableChanged: (data) => set({ hasEditableChanged: data }),
    }));
